import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { RESTE_ALL_AUTH_DATA, SET_ACCESS_TOKEN } from "../../../../../redux/action/auth/type";

const PhoneStep = ({ phone, setPhone, onNext }) => {
    const accessToken = useSelector((state) => state.auth.accessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [cookies] = useCookies(["refreshToken"]);

    const [loading, setLoading] = useState(false);

    const convertToEnglishDigits = (value) => {
        const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
        const arabicDigits = "٠١٢٣٤٥٦٧٨٩";

        return value
            .split("")
            .map((char) => {
                if (persianDigits.includes(char)) {
                    return persianDigits.indexOf(char).toString();
                }
                if (arabicDigits.includes(char)) {
                    return arabicDigits.indexOf(char).toString();
                }
                return char;
            })
            .join("");
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value;

        value = convertToEnglishDigits(value);

        // فقط عدد
        value = value.replace(/\D/g, "");

        setPhone(value);
    };

    const refreshAccess = async () => {
        try {
            const res = await axios.post(
                "https://my-sarad-back.liara.run/api/auth/refresh-token",
                { refreshToken: cookies?.refreshToken }
            );

            const newAccess = res.data?.accessToken;

            if (newAccess) {
                dispatch({ type: SET_ACCESS_TOKEN, payload: newAccess });
            }

            return newAccess;
        } catch (err) {
            return null;
        }
    };

    const sendPhoneChangeRequest = async (token) => {
        try {
            const res = await axios.post(
                "https://my-sarad-back.liara.run/api/user/request-phone-change",
                { newPhone: phone },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return res;
        } catch (err) {
            throw err;
        }
    };

    const handleSendOtp = async () => {
        if (!phone || phone.length !== 11) {
            toast.error("لطفا یک شماره موبایل معتبر وارد کنید");
            return;
        }

        if (!phone.startsWith("09")) {
            toast.error("شماره موبایل باید با 09 شروع شود");
            return;
        }

        try {
            setLoading(true);

            let token = accessToken;

            // اگر access token نداریم، اول refresh بزن
            if (!token) {
                token = await refreshAccess();

                if (!token) {
                    dispatch({ type: RESTE_ALL_AUTH_DATA });
                    toast.error("لطفا دوباره وارد حساب کاربری شوید");
                    navigate("/auth");
                    return;
                }
            }

            try {
                await sendPhoneChangeRequest(token);
            } catch (err) {
                // اگر access token منقضی یا نامعتبر بود، دوباره refresh کن
                const status = err?.response?.status;

                if (status === 401 || status === 403) {
                    const newAccess = await refreshAccess();

                    if (!newAccess) {
                        dispatch({ type: RESTE_ALL_AUTH_DATA });
                        toast.error("نشست شما منقضی شده، لطفا دوباره وارد شوید");
                        navigate("/auth");
                        return;
                    }

                    await sendPhoneChangeRequest(newAccess);
                } else {
                    throw err;
                }
            }

            toast.success("کد با موفقیت ارسال شد");
            onNext();
        } catch (err) {
            const msg = err?.response?.data?.message || "خطا در ارسال کد";
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-6 space-y-6">
            <div className="text-center space-y-2">
                <h3 className="text-lg font-bold text-slate-800">
                    تغییر شماره موبایل
                </h3>
                <p className="text-sm text-slate-500">
                    شماره موبایل جدیدتون رو وارد کنید
                </p>
            </div>

            <input
                type="tel"
                inputMode="numeric"
                value={phone}
                onChange={handlePhoneChange}
                placeholder="09xxxxxxxxx"
                maxLength={11}
                className="w-full h-12 rounded-xl border border-slate-200 px-4 focus:outline-none focus:border-[#8b6bd9]"
            />

            <button
                onClick={handleSendOtp}
                disabled={loading}
                className={`w-full h-12 rounded-xl bg-gradient-to-r from-[#543389] to-[#8b6bd9] text-white font-bold shadow-lg ${
                    loading ? "opacity-60 cursor-not-allowed" : ""
                }`}
            >
                {loading ? "در حال ارسال..." : "تایید و ارسال کد"}
            </button>
        </div>
    );
};

export default PhoneStep;
